<template>
  <v-btn
    v-show="['xs', 'sm'].includes($mq) && getEnableItemDates"
    color="blue darken-2 white--text"
    dark
    fixed
    bottom
    right
    depressed
    fab
    class="mb-12"
    @click="showDialogCartDatePicker = true"
  >
    <v-icon>mdi-calendar</v-icon>
  </v-btn>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'

export default {
  name: 'DatePickerFab',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapFields('cart', ['showDialogCartDatePicker']),
    ...mapGetters('shop', ['getEnableItemDates']),
  },
}
</script>
